import script from "./KLIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./KLIcon.vue?vue&type=script&lang=ts&setup=true"

import "./KLIcon.vue?vue&type=style&index=0&id=32e226ba&lang=scss"

const __exports__ = script;

export default __exports__